import React from 'react';
import { Outlet } from 'react-router-dom';
import CookieConsentModal from '../../features/cookies/components/CookieConsentModal';
import Footer from '../components/layout/Footer';
import Navbar from '../components/layout/Navbar';

export default function MainLayout() {
  return (
    <div className="App">
      <CookieConsentModal />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
